// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3063":"51955a9a","4357":"8d605721","5425":"b5108f2c","7278":"8d605721","9762":"b5108f2c"}[chunkId] + ".chunk.css";
};